// 📂 src/components/ProtectedRoute.tsx
import React from "react";
import { Navigate } from "react-router";
import { useAuthContext } from "../context/AuthContext";
import { getLocalStorage } from "../utils/localStorage";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // const user = useAuthContext();
  const user = getLocalStorage("user");
  console.log("useruser",user)
  if (!user) {
    return <Navigate to="/signin" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
